import { render, staticRenderFns } from "./MobileAppMain.vue?vue&type=template&id=276a8d9b&scoped=true&"
import script from "./MobileAppMain.vue?vue&type=script&lang=js&"
export * from "./MobileAppMain.vue?vue&type=script&lang=js&"
import style0 from "./MobileAppMain.vue?vue&type=style&index=0&id=276a8d9b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276a8d9b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('276a8d9b')) {
      api.createRecord('276a8d9b', component.options)
    } else {
      api.reload('276a8d9b', component.options)
    }
    module.hot.accept("./MobileAppMain.vue?vue&type=template&id=276a8d9b&scoped=true&", function () {
      api.rerender('276a8d9b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/MobileAppMain.vue"
export default component.exports